import React, { Component } from "react";
import withAuthorization from "../HOC/with.authorization";
import { IFirebaseAuthUser } from "../../interfaces/authentication.interfaces";
import { Link } from "react-router-dom";
import * as ROUTES from "../../constants/routes";
import GenericMapData from "./GenericMapData";
import { Feature, FeatureCollection, LineString, MultiLineString } from "geojson";
import {
  ILocation,
  IPipelineProperties,
} from "../../interfaces/map.interfaces";
import AuthenticationValidatorLogic from "../../logic/authenticationValidatorLogic";
import {IEventService, IPipelineService, ICrownClosureService} from "../../interfaces/services.interfaces";
import AppContext from "../../context/app.context";
import {
  toCrownClosurePathLocations,
  transformCrownClosureData,
} from "../../utils/crownClosureEvent.utils";
import { isCrownClosureProject } from "../../constants/map.consts";


interface IProps {
}

interface IState {
  locationsAndEventsData: ILocation[],
  crownClosureData:ILocation[]
  crownClosureGeoJsonData:FeatureCollection<LineString | MultiLineString, IPipelineProperties>
  pipelineDataGeoJson: FeatureCollection<LineString | MultiLineString, IPipelineProperties>,
}

class MapData extends Component<IProps, IState> {

  static contextType = AppContext;

  private eventService: IEventService;

  private crownClosureService: ICrownClosureService

  private pipelineService: IPipelineService;
  services: any;

  

  constructor(props: any, context: any) {

    super(props);

    const projectId = context.projects?.app || null;

    this.services = context.services;

    this.state = {
      locationsAndEventsData: [],
      crownClosureData: [],
      crownClosureGeoJsonData:null,
      pipelineDataGeoJson: null,
    };

    this.eventService = 
    projectId === "svi" ? this.services.sviEventService :
    projectId === "red" ? this.services.liaEventService :
    this.services.eventService;


    this.eventService.getMyData().then((data: any) => {
      this.setState({
        locationsAndEventsData: data?.data,
      });
      if (!(data?.data?.length)) {
        let outerThis = this;
        window.setTimeout(function() {
          outerThis.eventService.getMyData().then((newData: any) => {
            outerThis.setState({
              locationsAndEventsData: newData?.data,
            });
          }).catch((error: any) => {
            (window as any).encounteredError = true;
          });
        }, 2500);
      }
    }).catch((error: any) => {
      (window as any).encounteredError = true;
    });

  this.crownClosureService = this.services.crownClosureService

  if (isCrownClosureProject(projectId)) {
      this.crownClosureService.getMyData().then((data: any) => {
      const pathLocations = toCrownClosurePathLocations(data.data);

      const processedData = transformCrownClosureData(pathLocations);
      const separatedGeojsonList = processedData.map(item => item.separatedGeojson);

      const mergedFeatureCollection = {
        type: "FeatureCollection" as const,
        name: "Crown_Closure_Pipeline_Paths",
        crs: {
          type: "name",
          properties: {
            name: "urn:ogc:def:crs:OGC:1.3:CRS84"
          }
        },
        features: separatedGeojsonList.flatMap(fc =>
          fc.features?.map(f => ({
            type: "Feature" as const,
            geometry: f.geometry,
            properties: f.properties,
          }))
        )
      } as FeatureCollection<LineString | MultiLineString, IPipelineProperties> & { crs: any };

      this.setState({
        crownClosureData: data.data,
        crownClosureGeoJsonData: mergedFeatureCollection,
      });
    }).catch((error: any) => {
      (window as any).encounteredError = true;
    });
    }
  


    this.pipelineService = context.services.pipelineService;

    this.pipelineService.getMyData().then((data: any) => {
      this.setState({
        pipelineDataGeoJson: data?.data,
      })
      if (!(data?.data?.features?.length)) {
        let outerThis = this;
        window.setTimeout(function() {
          outerThis.pipelineService.getMyData().then((newData: any) => {
            outerThis.setState({
              pipelineDataGeoJson: newData?.data,
            });
          }).catch((error: any) => {
            (window as any).encounteredError = true;
          });
        }, 2500);
      }
    }).catch((error: any) => {
      (window as any).encounteredError = true;
    });
  }

  private refreshMounted = false;
  private refreshInFlight = false;

  componentDidMount() {
    this.refreshMounted = true;
    window.addEventListener("focus", this.refreshEventsOnFocus);
    document.addEventListener("visibilitychange", this.refreshEventsOnFocus);
  }

  componentWillUnmount() {
    this.refreshMounted = false;
    window.removeEventListener("focus", this.refreshEventsOnFocus);
    document.removeEventListener("visibilitychange", this.refreshEventsOnFocus);
  }

  private refreshEventsOnFocus = async () => {
    if (!this.refreshMounted || this.refreshInFlight || document.visibilityState === "hidden") return;
    this.refreshInFlight = true;
    try {
      const response: any = await this.eventService.getMyData();
      if (this.refreshMounted) {
        this.setState({ locationsAndEventsData: response?.data || [] });
      }
    } catch (error) {
      console.error("Refreshing map events failed", error);
    } finally {
      this.refreshInFlight = false;
    }
  };

  render() {

      return (
        <GenericMapData
          locationsAndEventsData={
            this.state.locationsAndEventsData
          }
          crownClosureData={
            this.state.crownClosureData
          }
          crownClosureGeoJsonData={
            this.state.crownClosureGeoJsonData
          }
          pipelineDataGeoJson={
            this.state.pipelineDataGeoJson
          }
          eventService={
            this.eventService
          }
        />
      );
  }
}

export const MapLink = () => (
  <p>
    Back to <Link to={ROUTES.MAP.route}>{ROUTES.MAP.label}</Link>
  </p>
);

const condition = (authUser: IFirebaseAuthUser) =>
  AuthenticationValidatorLogic.isAuthenticated(authUser);

export default withAuthorization(condition)(ROUTES.SIGN_IN.route)(MapData);
